import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { AgentLoadingFallback } from '../components/common'
import { useAuth } from '../context/auth/useAuth'
import { setFavicon } from '../utils/setFavicon'
import { setPageTitle } from '../utils/setPageTitle'

// const Cronos = createAgentLoader('cronos', () => import('cronos/app'))

export const Route = createFileRoute('/cronos/$')({
  component: CronosPage,
})

function CronosPage() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const hasCheckedInitialAuth = useRef(false)
  // useReloadOnBack()

  setFavicon('/assets/cronos-light-isotipo.png')
  setPageTitle('Cronos - Sofka Agents')

  // Solo verificar autenticación en el montaje inicial (ej: refresco de página)
  useEffect(() => {
    if (!hasCheckedInitialAuth.current) {
      hasCheckedInitialAuth.current = true
      if (!user) {
        navigate({ to: '/login' })
      }
    }
  }, [user, navigate])

  // Si no hay usuario en el primer render, mostrar loading mientras redirige
  if (!user && !hasCheckedInitialAuth.current) {
    return <AgentLoadingFallback />
  }

  return navigate({ to: '/' })

  // return (
  //   <Suspense fallback={<AgentLoadingFallback />}>
  //     <Cronos />
  //   </Suspense>
  // )
}
